import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import Grid from '@mui/material/Grid';

import {
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import {
  CalendarMonth,
  InfoOutlined,
} from '@mui/icons-material';
import { getSchedules } from '../../../../../redux/schedule/actions';
import { setTimezones } from '../../../../../redux/app/actions';
import Tasks from '../../../../task/Tasks';
import { getHorseLocations } from '../../../../../redux/horse/actions';

const SchedulesCardComponent = ({
  id,
  navigate,
  permissions,
  setTab,
}) => {
  const dispatch = useDispatch();
  const [sortModel] = React.useState([
    {
      field: 'startDate',
      sort: 'desc',
    },
  ]);

  // Redux state
  const currentHorseLodging = useSelector((state) => state.horse.currentHorseLodging);
  const {
    // schedules,
    schedules,
  } = useSelector((state) => state.schedule);

  React.useEffect(() => {
    dispatch(getHorseLocations(id, 0, 5, sortModel.map((s) => `&sort=${s.field},${s.sort}`))).then((horseLocations) => {
      if (horseLocations.content.length > 0) {
        const now = new Date();
        const sublist = horseLocations.content.filter((l) => new Date(l.startDate) < now
          && (l.endDate === null || new Date(l.endDate) > now));

        // setTimezone for horse current location
        if (sublist.length > 0) {
          dispatch(setTimezones(sublist[0].location.timezone))
        }
      }
    });
  }, [id]);

  // React state
  const [startDate] = React.useState(new Date());
  const [endDate] = React.useState(moment().add(3, 'months').endOf('day').toDate());

  React.useEffect(() => {
    if (currentHorseLodging && currentHorseLodging.pingumTagId) {
      dispatch(getSchedules(startDate, endDate, [currentHorseLodging.pingumTagId]));
    }
  }, [startDate, endDate, currentHorseLodging]);

  return (
    <Grid container spacing={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={9} xl={10}>
          <Tasks
            navigate={navigate}
            initialFilter={{ tagConditions: [[parseInt(currentHorseLodging.pingumTagId, 10)]] }}
            permissions={permissions}
            hideNav
            callbackOnAdd={() => { dispatch(getSchedules(startDate, endDate, [currentHorseLodging.pingumTagId])); }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <Typography
            sx={{
              fontWeight: 300,
              fontSize: 14,
              mt: 1,
            }}
          >Only started and/or already created tasks will show in this list (depending on your selected filters)
          </Typography>
          <Typography
            sx={{
              fontWeight: 300,
              fontSize: 14,
            }}
          >Tasks scheduled for the future can be viewed from the
            <Button
              onClick={() => { setTab(7); }}
              size="small"
              sx={{
                m: 0,
                ml: 0.5,
                p: 0,
              }}
            >
              Calendar View
            </Button>.
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <InfoOutlined
              color="secondary"
              sx={{
                fontSize: 40,
                m: 2,
              }}
            />
            <Typography sx={{ fontWeight: 300 }}>
              {
                schedules && schedules.length > 0
                  ? 'There Are Scheduled Tasks'
                  : 'No Scheduled Tasks'
              }
            </Typography>
            <Button onClick={() => { setTab(7); }} startIcon={<CalendarMonth />}>{(schedules && schedules.length > 0)
              ? 'View Them In The Calendar'
              : 'View Calendar'}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

SchedulesCardComponent.propTypes = {
  id: PropTypes.any.isRequired,
  navigate: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  setTab: PropTypes.func.isRequired,
};

export default SchedulesCardComponent;
